<template>
  <div class="header">
    <NavigationBar :menu="menu" :menu-active="isActive" @open="openMenu" />
    <ClientOnly>
      <NavigationSidebar
        v-if="!isDesktop"
        :menu="menu"
        :active="isActive"
        @close="closeMenu"
      />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { useHeaderSettings } from '@/state/headerSettings'

const menu = await useHeaderSettings()

const isDesktop = useIsDesktop()
const isActive = ref(false)

const openMenu = () => (isActive.value = true)
const closeMenu = () => (isActive.value = false)
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  z-index: z(header-navigation);
}
</style>
